import { types, getParent, flow, applySnapshot } from 'mobx-state-tree';

export const CallsAmount = types.model('CallsAmount', {
    resetDate: types.string,
    firstDate: types.string,
    lastDate: types.string,    
    madeNationalCalls: types.number,   
    madeInternationalCalls: types.number, 
    nationalCallTime: types.string, 
    internationalCallTime: types.string,      
})
    .views(self => ({
        get loggedinUser() {
            return getParent(self);
        },
        get totalMadeCalls(): number {
            return self.madeNationalCalls + self.madeInternationalCalls;
        },
        get period(): string {
            //use firstDate and lastDate (ex. 20180301, 20180331) to set period(ex. 1 mars - 31 mars):
            if (self.firstDate !== '' && self.lastDate !== '') { 
                //dates:
                let firstDateLongStr: string = dateAsDayAndMonth(self.firstDate);
                let lastDateLongStr: string = dateAsDayAndMonth(self.lastDate);
                
                //period like '1 mars - 31 mars'
                return firstDateLongStr + ' - ' + lastDateLongStr;
            } else {
                return ' ';
            }
        },      
        
    }))
    .actions(self => ({
        updateMsgAmount(json: string) {
            applySnapshot(self, JSON.parse(json));
        },

        // setTest() {
        //     self.resetDate = '20180224';
        //     self.madeNationalCalls = 10;
        //     self.nationalCallTime = '04:20:02';
        //     self.madeInternationalCalls = 2;
        //     self.internationalCallTime = '00:12:14';                        
        // },
        
    }));

export default CallsAmount;

//--------------------------
// Help functions
//--------------------------
function dateAsDayAndMonth(YYYYMMDDdateStr: string): string {
// returns date as string with format:
// day in month + ' ' + month as long text (ex '31 mars')
//

    const monthsAsText: string[] = 
                        ['januari', 'februari', 'mars', 'april', 'maj', 'juni', 
                         'juli', 'augusti', 'september', 'oktober', 'november', 'december'];

    //date's day as day in month(1..31)            
    let dayInMonth: string = YYYYMMDDdateStr.substring(6, 7) === '0' ? 
    YYYYMMDDdateStr.substring(7) : YYYYMMDDdateStr.substring(6);

    //date's month as long text(januari..december)
    let month: number = YYYYMMDDdateStr.substring(4, 5) === '0' ? 
        Number(YYYYMMDDdateStr.substring(5, 6)) : Number(YYYYMMDDdateStr.substring(4, 6));
    let monthAsText = monthsAsText[month - 1];

    //date as day in month and month as long text(ex '31 mars')
    return dayInMonth + ' ' + monthAsText;
}



// WEBPACK FOOTER //
// ./src/models/CallsAmount.ts